import React from 'react'
import { CustomerBadge } from '@vend/react-utilities'
import { ApiCustomer, CustomerGroup } from '@vend/types'

import { reactular } from '@vendhq/reactular'

interface Props {
  customer: ApiCustomer
  group?: CustomerGroup
  interactive?: 'selection' | 'action'
  size: 'small' | 'x-small'
  noDescription?: boolean
}

const ReactCustomerBadge: React.FC<Props> = ({
  customer,
  group,
  interactive,
  size,
  noDescription = false,
}) => {
  return (
    <CustomerBadge
      apiCustomer={customer}
      group={group}
      size={size}
      interactive={interactive}
      noDescription={noDescription}
    />
  )
}

export const ReactCustomerBadgeComponent = reactular<Props>(
  ReactCustomerBadge,
  ['customer', 'group', 'interactive', 'size', 'noDescription']
)
